import { useMemo } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { formatName } from "../utils/namesFormater";

import { useContacts } from "./crm/useContacts";
import { useLeads } from "./crm/useLeads";
import { formatLeadName } from "../utils/leadUtil";


export const useContactNameColumn = (): GridColDef => {
  const { data: contacts = [] } = useContacts();

  return {
    field: "contact_id",
    headerName: "לקוח",
    width: 170,
    valueGetter: (params: any) => {
      const contact = contacts.find((c) => c.id === params);
      return contact ? formatName(contact) : "";
    },
    renderCell: (params: any) => {
      return params.value ? params.value : "—";
    },
  };
};

export const useManualMimshakContactNameColumn = (): GridColDef => {
  const { data: contacts = [] } = useContacts();

  return {
    field: "contact_id",
    headerName: "לקוח",
    width: 170,
    valueGetter: (value: any, row: any) => {
      if (row?.is_family) return "משפחה";
      const contact = contacts.find((c) => c.id === value);
      return contact ? formatName(contact) : "";
    },
    renderCell: (params: any) => {
      return params.value ? params.value : "—";
    },
  };
};

export const useContactFirstNameColumn = (): GridColDef => {
  const { data: contacts = [] } = useContacts();

  return {
    field: "contact_id",
    headerName: "לקוח",
    width: 90,
    valueGetter: (params: any) => {
      const contact = contacts.find((c) => c.id === params);
      return contact?.first_name ?? "";
    },
    renderCell: (params: any) => params.value || "—",
  };
};

export const useLeadNameColumn = (): GridColDef => {
  const { data: leads = [] } = useLeads();

  return {
    field: "lead_id",
    headerName: "ליד",
    width: 170,
    valueGetter: (params: any) => {
      const lead = leads.find((l) => l.id === params);
      return lead ? formatLeadName(lead) : "";
    },
    renderCell: (params: any) => params.value || "—",
  };
};

export const useRevClientColumn = (): GridColDef => {
  const { data: contacts = [] } = useContacts();

  return {
    field: "rev_client",
    headerName: "לקוח REV&U",
    width: 110,
    sortable: true,
    valueGetter: (_params: any, row: any) => {
      const contact = contacts.find((c) => c.id === row.contact_id);
      return contact?.rev_client === true ? "REV&U" : "";
    },
    renderCell: (params: any) => params.value === "REV&U" ? params.value : null,
  };
};